<template>
  <div>
    <vs-prompt
      :title="titleText"
      @cancel="val = ''"
      @accept="acceptAddNewTodoPrompt"
      @close="closeAddNewTodoPrompt"
      :active.sync="addNewTodoPrompt"
      :accept-text="titleText"
      :is-valid="validForm"
      class="todoPopup"
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Title</span>
            </div>
            <div class="vx-col sm:w-5/6 w-full">
              <vs-input
                class="inputx w-full"
                placeholder="Example: empty trash"
                v-model="todo_title"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Note</span>
            </div>
            <div class="vx-col sm:w-5/6 w-full">
              <vx-tooltip
                text="Use note if there is something extra you'd like to remember"
                position="bottom"
              >
                <vs-input
                  class="inputx w-full"
                  placeholder="Note"
                  v-model="todo_note"
                />
              </vx-tooltip>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Place</span>
            </div>
            <div class="vx-col sm:w-5/6 w-full">
              <vx-tooltip
                text="Use this tohelp you remember where this todo takes place."
                position="top"
              >
                <gmap-autocomplete
                  class="addressInput vs-inputx vs-input--input normal"
                  placeholder="Type location or address"
                  @place_changed="updateAddress"
                  :value="todo_address"
                  :select-first-on-enter="true"
                >
                  <template v-slot:input="slotProps">
                    <v-text-field
                      outlined
                      prepend-inner-icon="place"
                      placeholder="Type location or address"
                      ref="input"
                      v-on:listeners="slotProps.listeners"
                      v-on:attrs="slotProps.attrs"
                    >
                    </v-text-field>
                  </template>
                </gmap-autocomplete>
              </vx-tooltip>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Due date</span>
            </div>
            <div class="vx-col sm:w:1/6">
              <vx-tooltip
                text="Help yourself remember when this todo is due"
                position="top"
              >
                <vs-checkbox v-model="hasDueDate">Has due date</vs-checkbox>
              </vx-tooltip>
            </div>
          </div>

          <transition name="fade">
            <div class="vx-row mb-6" v-if="hasDueDate">
              <div class="vx-col sm:w-1/6 w-full">
                <span>Date</span>
              </div>
              <div class="vx-col sm:w-5/6 w-full">
                <flat-pickr
                  :config="datePickerConfigStart"
                  v-model="todo_dueDate"
                  class="p-3 s-inputx vs-input--input flex"
                  placeholder="Day..."
                  style="display: flex; width: 100%"
                /><br />
                <vx-tooltip
                  text="Enable to receive a notification in the LIFE app when todo is due"
                  position="top"
                >
                  <vs-checkbox v-model="notifyMe"
                    >Notify in LIFE app</vs-checkbox
                  >
                </vx-tooltip>
              </div>
            </div>
          </transition>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Flagged</span>
            </div>
            <div class="vx-col">
              <vx-tooltip
                :text="
                  todo_flagged
                    ? 'Click to remove flag'
                    : 'Click to mark this todo with a flag'
                "
                position="bottom"
              >
                <feather-icon
                  v-if="!todo_flagged"
                  icon="FlagIcon"
                  svgClasses="w-6 h-6 hover:text-primary cursor-pointer"
                  @click.stop="todo_flagged = true"
                />
                <feather-icon
                  v-if="todo_flagged"
                  icon="FlagIcon"
                  svgClasses="w-6 h-6 text-warning cursor-pointer"
                  @click.stop="todo_flagged = false"
                />
              </vx-tooltip>
            </div>
          </div>

          <div class="buttons-footer-left">
            <vs-button
              v-if="!isNew"
              color="danger"
              @click.native="confirmDelete"
              type="border"
              class=""
              >Delete</vs-button
            >
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>

<script>
import _ from "lodash";
import flatPickr from "vue-flatpickr-component";

import moment from "moment";

import TypeAhead from "vue2-typeahead";
const TodoImages = () => import("./TodoImages.vue");

export default {
  components: {
    TodoImages,
    TypeAhead,
    flatPickr,
  },
  data() {
    return {
      isNew: false,
      categoryId: "",
      todo_address: "",
      todo_longitude: 0,
      todo_latitude: 0,
      todo_flagged: false,
      completed: false,
      notifyMe: false,
      hasDueDate: false,

      momentFormat: "DD-MM-YYYY", // "DD-MM-YYYY HH:mm" for time
      todo_id: "",
      todo_title: "",
      todo_note: "",
      todo_dueDate: null,
      addNewTodoPrompt: false,
      datePickerConfigStart: {
        enableTime: false, // Set to true for time again
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        dateFormat: "d-m-Y", // "d-m-Y H:i" for time
        defaultHour: 12,
        defaultMinute: 30,
        defaultSecond: 0,
      },
    };
  },
  computed: {
    validForm() {
      return this.todo_title !== "";
    },
    titleText() {
      return (this.isNew ? "Add " : "Update ") + "todo";
    },
  },
  methods: {
    updateAddress: function (payload) {
      this.todo_address = payload.formatted_address;
      const lat = payload.geometry.location.lat();
      const lng = payload.geometry.location.lng();

      this.todo_latitude = lat;
      this.todo_longitude = lng;

      /*this.street =
        this.getAddressComponent(payload, "route") +
        " " +
        this.getAddressComponent(payload, "street_number");
      this.city = this.getAddressComponent(payload, "locality");
      this.postalCode = this.getAddressComponent(payload, "postal_code");
      this.country = this.getAddressComponent(payload, "country");*/
    },

    getAddressComponent: function (address, component) {
      var result = address.address_components.filter((cmp) => {
        if (cmp.types.includes(component)) {
          return true;
        }

        return false;
      });

      if (result.length == 0) {
        return "";
      }

      return result[0].long_name;
    },

    confirmDelete() {
      this.addNewTodoPrompt = false;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Delete todo?",
        accept: this.deleteEvent,
      });
    },
    async deleteEvent() {
      this.$vs.loading();

      await this.$store.dispatch("personalTodos/deleteTodo", {
        todoId: this.todo_id,
        categoryId: this.categoryId,
      });

      this.$vs.loading.close();
      this.$vs.notify({
        color: "danger",
        title: "Deleted todo",
        text: "The todo was deleted",
      });
    },
    show() {
      this.isNew = true;
      this.selectedVenues = [];
      this.todo_flagged = false;
      this.todo_address = "";
      this.todo_longitude = 0;
      this.todo_latitude = 0;

      this.addNewTodoPrompt = true;
      this.data = "";

      this.todo_title = "";
      this.todo_note = "";

      this.notifyMe = false;
      this.hasDueDate = false;

      //this.todo_dueDate = null;
      this.todo_dueDate = moment().format(this.momentFormat);
    },
    showWith(data) {
      console.log("Showing with todo", data);
      this.isNew = false;
      this.categoryId = data.categoryId;
      this.todo_id = data.id;
      this.todo_title = data.title;
      this.notifyMe = data.notifyMe;
      this.hasDueDate = data.hasDueDate;
      this.todo_note = data.note;
      this.todo_dueDate = moment(data.dueDateUtcTicks).format(
        this.momentFormat
      );
      this.todo_flagged = data.flagged;
      this.todo_address = data.address;
      this.todo_longitude = data.longitude;
      this.todo_latitude = data.latitude;
      this.addNewTodoPrompt = true;
    },
    async acceptAddNewTodoPrompt() {
      const event = {
        title: this.todo_title,
        note: this.todo_note,
        dueDate: moment(this.todo_dueDate, this.momentFormat).format(), // valueOf for unix
        flagged: this.todo_flagged,
        notifyMe: this.notifyMe,
        hasDueDate: this.hasDueDate,
        address: this.todo_address,
        latitude: this.todo_latitude,
        longitude: this.todo_longitude,
      };

      this.$vs.loading();
      if (this.isNew) {
        await this.$store.dispatch("personalTodos/createTodo", event);
      } else {
        await this.$store.dispatch("personalTodos/updateTodo", {
          todoId: this.todo_id,
          categoryId: this.categoryId,
          todo: event,
        });
      }

      this.$vs.notify({
        color: "success",
        title: `Todo ${this.isNew ? "added" : "updated"}`,
        text: `Your todo was ${this.isNew ? "added" : "updated"}`,
      });
      this.$vs.loading.close();
    },
    closeAddNewTodoPrompt() {},
  },
};
</script>

<style lang="scss" scoped>
.addressInput {
  width: 100%;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.buttons-footer-left {
  position: absolute;
  bottom: 14px;
  z-index: 100;
  animation: fadeIn ease 500ms forwards;
  animation-delay: 500ms;
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.typeahead-container input {
  padding: 0.7rem !important;
  font-size: 1rem !important;
  color: inherit;
  position: relative;
  padding: 0.4rem;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  width: 100%;
}
</style>

<style lang="scss"  >
.todoPopup.con-vs-dialog .vs-dialog {
  max-width: 600px !important;
  position: relative;
}
.pac-container {
  z-index: 1000000;
}
</style>
